import React from 'react'
import Add from './add'
import { AccordionWithArrow } from '../../../../components'
import { Wrapper } from './style'

const CopyKeywordMapping = () => {
  return (
    <Wrapper>
        <AccordionWithArrow title='Copy Keyword Mapping' expanded={true} accordionstyle='fieldset'>
            <Add />
        </AccordionWithArrow>
    </Wrapper>
  )
}

export default CopyKeywordMapping
